import { useEffect, useMemo, useState } from 'react';
import { shallow } from 'zustand/shallow';

import { VEHICLE_LIST_FILTER_NAME } from 'Components/VehicleList/VehicleListFilters.consts';
import useVehicleFilterStore from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import useMakesStore from 'Stores/MakesStore/MakesStore';
import useModelsStore from 'Stores/ModelsStore/ModelsStore';
import { filterModelsByMakes, getMakesIds } from 'Utilities/makeModel/makeModel.helpers';

const useModelsFilter = () => {
	const [modelsBySelectedMakes, setModelsBySelectedMakes] = useState([]);
	const [allMakes, getMakesBySlugs] = useMakesStore((store) => [store.makes, store.getMakesBySlugs], shallow);
	const [allModels, getModelsById, getModelsByMakeIds] = useModelsStore(
		(store) => [store.models, store.getModelsById, store.getModelsByMakeIds],
		shallow,
	);
	const [filters, config, setValue] = useVehicleFilterStore(
		(store) => [store.filters, store.config, store.setValue],
		shallow,
	);
	const { make, model } = filters;
	const {
		model: { id: modelConfigId },
	} = config;

	const makeIds = useMemo(() => {
		if (!allMakes.length) {
			return [];
		}
		const makesBySlugs = getMakesBySlugs(make);
		return getMakesIds(makesBySlugs);
	}, [allMakes, getMakesBySlugs, make]);

	useEffect(() => {
		if (!allModels.length) {
			return;
		}
		const modelsByMakeIds = getModelsByMakeIds(makeIds);
		setModelsBySelectedMakes(modelsByMakeIds);
	}, [makeIds, allModels, getModelsByMakeIds]);

	useEffect(() => {
		if (!allModels.length) {
			return;
		}

		const selectedModels = filterModelsByMakes({
			makeIds,
			models: getModelsById(model),
		});

		setValue({ id: VEHICLE_LIST_FILTER_NAME.MODEL, value: selectedModels });
	}, [setValue, makeIds, model, allModels, getModelsById]);

	return { model, modelConfigId, modelsBySelectedMakes };
};

export default useModelsFilter;
